const urlRelatoriosLog = "/v1/RelatoriosLog";

const service = {
  methods: {
    $obterRelatorioLogGrupo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogGrupo`, params);
    },
    $obterRelatorioLogCSVGrupo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogGrupoCsv`, params);
    },
    $obterRelatorioLogPDFGrupo(params) {
      return this.$api().get(`${urlRelatoriosLog}/RelatorioLogGrupoPdf`, this.$getParamsObject(params));
    },
  }
};

export default service;
